import { FF_AD_SDK_2 } from '@wetransfer/transfer/constant/experiments';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export const isAdSDK2Enabled = (): boolean =>
  getFullVariant(FF_AD_SDK_2).value === 'on';
